import { Injectable } from '@angular/core';

import { HttpClient } from '@angular/common/http';
import { Observable, of } from 'rxjs';

import { Persona } from './entity-personas.model';
import * as moment from 'moment';

@Injectable({
  providedIn: 'root'
})
export class PersonasService {
  url: string;
  token: string;
  endpoint = 'personas';

  constructor(private http: HttpClient) { }

  getPersonas(): Observable<Persona[]> {
    return this.http.get<Persona[]>(`${this.url}/${this.endpoint}/`);
  }

  addPersona(persona: Persona): Observable<Persona> {
    return this.http.post<Persona>(`${this.url}/${this.endpoint}/`, {
      ...persona,
      fecha_nacimiento: this.formatDate(
        persona.fecha_nacimiento as unknown as string
      )
    });
  }

  changePersona(p: Persona): Observable<Persona> {
    return this.http.patch<Persona>(`${this.url}/${this.endpoint}/${p.id}/`, {
      ...p,
      fecha_nacimiento: this.formatDate(p.fecha_nacimiento as unknown as string)
    });
  }

  deletePersona(p: Persona): Observable<Persona> {
    return this.http.delete<Persona>(`${this.url}/${this.endpoint}/${p.id}`);
  }

  formatDate(inputDate: string): string {
    try {
      const parts = inputDate.split('/');
      const day = parts[0].padStart(2, '0');
      const month = parts[1].padStart(2, '0');
      const year = parts[2];
      return `${year}-${month}-${day}`;
    } catch (error) {
      return inputDate;
    }
  }
}
